import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/qcode.png'
import _imports_1 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-4b9a7cce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"5px 5px","text-align":"center"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-text" }, [
  /*#__PURE__*/_createTextVNode(" 请使用微信扫描下方二维码打开 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "qcode-image"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-text" }, "欢迎来到广西大学校友足球协会", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-image",
  src: _imports_1
}, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("微信登录")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.option.browserType != 'Wechat')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_ctx.option.browserType == 'Wechat')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createVNode(_component_van_button, {
              onClick: _ctx.LoginWithWechat,
              type: "primary",
              round: "",
              block: ""
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
  ]))
}